import clientAgreementReportSlice from "./clientAgreement";
import feeDetailsReportSlice from "./feeDetailsReports";
import headCountDetailsSlice from "./headCountDetails";
import DueDetailsAndDueDetailsBreakupReportSlice from "./dueDetailsAndBreakupReport";
import creditNoteDetailsReportSlice from "./creditNoteDetailsReports";
import centerAreaDueDetailsSlice from "./centerAreaDueDetails";
import invoiceTallyDetailsSlice from "./invoiceTallyDetails";
import latePaymentFeeDetailsSlice from "./latePaymentFeeDetails";
import DueDetailsReportSlice from "./deuDetailsReports";
const reducersReports = {
  clientAgreementReport: clientAgreementReportSlice,
  feeDetailsReports: feeDetailsReportSlice,
  headCountDetails: headCountDetailsSlice,
  dueDetailsAndDueDetailsBreakupReport:
    DueDetailsAndDueDetailsBreakupReportSlice,
  creditNoteDetailsReports: creditNoteDetailsReportSlice,
  centerAreaDueDetails: centerAreaDueDetailsSlice,
  invoiceTallyDetails: invoiceTallyDetailsSlice,
  latePaymentFeeDetails: latePaymentFeeDetailsSlice,
  deuDetailsReports: DueDetailsReportSlice,
};
export default reducersReports;
